export const COOKIE_CONSENTS_SESSION_STORAGE_KEY = 'chosenCookieConsentIds';
